//存储localstorage
export const setStore = (name, content) => {
  if (!name) return;
  window.localStorage.setItem(name, JSON.stringify(content));
}

//获取localstorage
export const getStore = name => {
  if (!name) return;
  return JSON.parse(window.localStorage.getItem(name));
}

//删除localstorage
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}